/**
 * 动态加载 AI 支付助手 SDK（hw.agentchat.js → window.AgentChat）
 */

const AGENT_CHAT_SCRIPT_URL = '//abres.octlib.com/common/chat/hw.agentchat.js?v=20260910';

let loadScriptPromise = null;

export function isAgentChatReady() {
  const api = typeof window !== 'undefined' ? window.AgentChat : null;
  return !!(api && typeof api.loadAgentChatSDK === 'function');
}

export function getAgentChatApi() {
  if (!isAgentChatReady()) {
    throw new Error(
      'AgentChat UMD 未加载。请先调用 loadAgentChatScript() 加载 hw.agentchat.js',
    );
  }
  return window.AgentChat;
}

/** 幂等加载 SDK 脚本 */
export function loadAgentChatScript() {
  if (isAgentChatReady()) {
    return Promise.resolve();
  }
  if (loadScriptPromise) {
    return loadScriptPromise;
  }

  loadScriptPromise = new Promise((resolve, reject) => {
    const fail = (msg) => {
      loadScriptPromise = null;
      reject(new Error(msg));
    };

    const existing = document.querySelector('script[src*="hw.agentchat.js"]');
    if (existing) {
      if (isAgentChatReady()) {
        resolve();
        return;
      }
      existing.addEventListener('load', () => {
        if (isAgentChatReady()) resolve();
        else fail('hw.agentchat.js loaded but AgentChat API missing');
      });
      existing.addEventListener('error', () => fail('load hw.agentchat.js failed'));
      return;
    }

    const script = document.createElement('script');
    script.src = AGENT_CHAT_SCRIPT_URL;
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.onload = () => {
      if (isAgentChatReady()) resolve();
      else fail('hw.agentchat.js loaded but AgentChat API missing');
    };
    script.onerror = () => fail('load hw.agentchat.js failed');
    document.head.appendChild(script);
  });

  return loadScriptPromise;
}
